import { api } from "../api";

export interface ActiveOperation {
  operation_id: string;
  operation_type: string;
  entity_id: string;
  status: string;
  title: string;
  started_at: string;
  updated_at: string;
  user_id: number;
}

export const operationService = {
  /** Get all active operations for the current user. */
  getActive: () => api.get<{ data: ActiveOperation[] }>("/operations/active"),

  /** Get the status of a specific operation. */
  getStatus: (opId: string) => api.get<{ data: ActiveOperation }>(`/operations/${opId}`),
};
